import React from 'react';
import { initialSteps } from './initialSteps';
import FormContainer from '../../components/Form/FormContainer';
import { formTypes } from '../../constants';

const DataExchangeLayerForm = props => (
  <FormContainer
    initialSteps={initialSteps}
    serviceType={formTypes.DATAEXCHANGELAYER}
    {...props}
  />
);

export default DataExchangeLayerForm;
